import { GeoPoint } from '@angular/fire/firestore';

export class Rider {
  constructor(
    public riderId: string,
    public name: string,
    public primaryContact: string,
    public email?: string,
    public geoLocation?: GeoPoint,
    public status?: string,
    public zone?: string,
    public state?: string,
    public  city?: string
  ) {}
}

export enum RiderStatus {
  AVAILABLE = 'AVAILABLE',
  UNAVAILABLE = 'UNAVAILABLE',
  ONJOB = 'ONJOB'
}